// import React, { useRef } from "react";
// import { useLocation, Link } from "react-router-dom";
// import Barcode from "react-barcode";

// export default function BarcodeListPrint() {
//   const location = useLocation();
//   const { selectedDesigns } = location.state || { selectedDesigns: [] };

//   const queryParams = new URLSearchParams(location.search);
//   const backPage = parseInt(queryParams.get("page"));
//   const search = queryParams.get("search");

//   console.log("selectedDesigns", selectedDesigns);

//   const barcodeRef = useRef(null);

//   const handlePrint = () => {
//     if (barcodeRef.current) {
//       const printWindow = window.open("", "_blank");
//       if (printWindow) {
//         printWindow.document.open();
//         printWindow.document.write(`
//           <!DOCTYPE html>
//           <html>
//             <head>
//               <style>
//                 @media print {
//                   body {
//                     margin: 0;
//                     padding: 0;
//                     font-family: Arial, sans-serif;
//                     font-size: 12px;
//                   }
//                   .row {
//                     display: flex;
//                     flex-wrap: wrap;
//                     margin: 0;
//                   }
//                     .col-md-6 {
//                     display: inline-block;
//                     width: 50%; /* Adjust for two labels per row */
//                     margin: 0;
//                     padding: 0;
//                   }
//                   .col-sm-6 {
//                     display: inline-block;
//                     width: 50%; /* Adjust for two labels per row */
//                     margin: 0;
//                     padding: 0;
//                   }
//                     .col-sm-4 {
//                     display: inline-block;
//                     width: 40%; /* Adjust for two labels per row */
//                     margin: 0;
//                     padding: 0;
//                   }
//                     .col-sm-2 {
//                     display: inline-block;
//                     width: 10%; /* Adjust for two labels per row */
//                     margin: 0;
//                     padding: 0;
//                   }
//                   .card {
//                     box-shadow: none;
//                     border: none;
//                     margin: 0 auto;
//                   }
//                   .card-body {
//                     padding: 10mm; /* Adjust padding for better fit */
//                     text-align: center;
//                   }
//                 }
//                 .col-sm-6 {
//                   display: inline-block;
//                   width: 50%; /* Adjust for two labels per row */
//                   margin: 0;
//                   padding: 0;
//                 }
//                 .card {
//                   margin: 0 auto;
//                   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//                 }
//                 .card-body {
//                   padding: 10mm;
//                   text-align: center;
//                 }
//               </style>
//             </head>
//             <body>
//               <div class="row">
//                 ${barcodeRef.current.outerHTML}
//               </div>
//             </body>
//           </html>
//         `);
//         printWindow.document.close();
//         printWindow.focus();
//         printWindow.print();
//         printWindow.close();
//       }
//     }
//   };

// import React from "react";
// import Barcode from "react-barcode";
// import { useLocation, Link } from "react-router-dom";
// import JsBarcode from "jsbarcode";
// const pdfMake = require("pdfmake/build/pdfmake");
// const pdfFonts = require("pdfmake/build/vfs_fonts");

// pdfMake.vfs = pdfFonts.vfs;

// export default function BarcodeListPrint() {
//   const location = useLocation();
//   const { selectedDesigns } = location.state || { selectedDesigns: [] };

//   const queryParams = new URLSearchParams(location.search);
//   const backPage = parseInt(queryParams.get("page"));
//   const search = queryParams.get("search");

//   const formatPrice = (rate) => {
//     const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
//     return price >= 1000
//       ? `4${price.toString().charAt(0)} / ${price
//           .toString()
//           .slice(-3)
//           .padStart(3, "0")}`
//       : `4${price.toString().charAt(0)} / ${price
//           .toString()
//           .slice(-2)
//           .padStart(2, "0")}`;
//   };

//   const generateBarcodeDataUrl = (text) => {
//     const canvas = document.createElement("canvas");
//     JsBarcode(canvas, text, {
//       displayValue: false,
//       width: 1.5,
//       height: 60,
//       margin: 0,
//     });
//     return canvas.toDataURL("image/png");
//   };

//   const handlePrint = async () => {
//   const content = await Promise.all(
//     selectedDesigns.map(async (design, index) => {
//       const barcodeImage = generateBarcodeDataUrl(design.design_id);

//       const label = {
//         stack: [
//           { image: barcodeImage, width: 220, alignment: "center" },
//           {
//             table: {
//               widths: ["*", "*"],
//               body: [
//                 [
//                   { text: design.brand_name, fontSize: 10 },
//                   {
//                     text: design.design_id,
//                     alignment: "right",
//                     fontSize: 10,
//                   },
//                 ],
//                 [
//                   { text: formatPrice(design.design_rate), fontSize: 10 },
//                   {
//                     text: design.barcode_date,
//                     alignment: "right",
//                     fontSize: 10,
//                   },
//                 ],
//               ],
//             },
//             layout: "noBorders",
//             margin: [22, 5, 22, 0],
//           },
//         ],
//         margin: [5, 5, 5, 5],
//       };

//       // ✅ Add page break only if it's NOT the last item
//       if (index !== selectedDesigns.length - 1) {
//         label.stack.push({ text: "", pageBreak: "after" });
//       }

//       return label;
//     })
//   );

//   const docDefinition = {
//     pageSize: { width: 283, height: 141 }, // 100mm x 50mm
//     pageMargins: [5, 5, 5, 5],
//     content,
//   };

//   pdfMake.createPdf(docDefinition).print(); // directly opens print dialog
// };

//   return (
//     <div className="content-body">
//       <div className="container-fluid">
//         <div className="form-head d-flex justify-content-between align-items-center mb-3">
//           <h4>Barcode List</h4>
//           <div className="d-flex align-items-center">
//             <img
//               src="/assets/images/kidskart/icon/printer.png"
//               alt="Print Icon"
//               className="cursor-pointer me-3"
//               onClick={handlePrint}
//               title="Print Barcodes"
//             />
//             <Link
//               to={`/rate-diary/list?page=${backPage}${
//                 search ? `&search=${search}` : ""
//               }`}
//             >
//               <img
//                 src="/assets/images/kidskart/icon/back-button.png"
//                 alt="Back"
//                 title="Back to Designs"
//               />
//             </Link>
//           </div>
//         </div>

//         {/* Optional Preview */}
//         <div className="row p-4">
//           {selectedDesigns.map((design, index) => (
//             <div className="col-md-6" key={index}>
//               <div className="card p-3 text-center">
//                 <img
//                   src={generateBarcodeDataUrl(design.design_id)}
//                   alt="Barcode"
//                   style={{ height: 75 }}
//                 />
//                 <div className="mt-2 row text-start">
//                   <div className="col-sm-4">{design.brand_name}</div>
//                   <div className="col-sm-6">{design.design_id}</div>
//                   <div className="col-sm-4">
//                     {formatPrice(design.design_rate)}
//                   </div>
//                   <div className="col-sm-6">{design.barcode_date}</div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// import React from "react";
// import { useLocation, Link } from "react-router-dom";
// import JsBarcode from "jsbarcode";
// import Barcode from "react-barcode";
// const pdfMake = require("pdfmake/build/pdfmake");
// const pdfFonts = require("pdfmake/build/vfs_fonts");

// pdfMake.vfs = pdfFonts.vfs;

// export default function BarcodeListPrint() {
//   const location = useLocation();
//   const { selectedDesigns } = location.state || { selectedDesigns: [] };

//   const queryParams = new URLSearchParams(location.search);
//   const backPage = parseInt(queryParams.get("page"));
//   const search = queryParams.get("search");

//   const formatPrice = (rate) => {
//     const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
//     return price >= 1000
//       ? `4${price.toString().charAt(0)} / ${price.toString().slice(-3).padStart(3, "0")}`
//       : `4${price.toString().charAt(0)} / ${price.toString().slice(-2).padStart(2, "0")}`;
//   };

//   // ✅ High-resolution barcode generation using SVG + canvas
//   const generateBarcodeDataUrl = (text) => {
//     return new Promise((resolve) => {
//       const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//       JsBarcode(svg, text, {
//         format: "CODE128",
//         displayValue: false,
//         width: 2.4, // Wider bars
//         height: 80,
//         margin: 0,
//         background: "#ffffff",
//         lineColor: "#000000",
//       });

//       const svgData = new XMLSerializer().serializeToString(svg);
//       const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
//       const url = URL.createObjectURL(svgBlob);

//       const img = new Image();
//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         canvas.width = img.width * 2; // Scale 2x for sharp output
//         canvas.height = img.height * 2;
//         const ctx = canvas.getContext("2d");
//         ctx.scale(2, 2);
//         ctx.drawImage(img, 0, 0);
//         URL.revokeObjectURL(url);
//         resolve(canvas.toDataURL("image/png"));
//       };
//       img.src = url;
//     });
//   };

//   const handlePrint = async () => {
//     const content = await Promise.all(
//       selectedDesigns.map(async (design, index) => {
//         const barcodeImage = await generateBarcodeDataUrl(design.design_id);

//         const label = {
//           stack: [
//             { image: barcodeImage, width: 260, alignment: "center" },
//             {
//               table: {
//                 widths: ["*", "*"],
//                 body: [
//                   [
//                     { text: design.brand_name, fontSize: 10 },
//                     { text: design.design_id, alignment: "right", fontSize: 10 },
//                   ],
//                   [
//                     { text: formatPrice(design.design_rate), fontSize: 10 },
//                     { text: design.barcode_date, alignment: "right", fontSize: 10 },
//                   ],
//                 ],
//               },
//               layout: "noBorders",
//               margin: [12, 5, 12, 0],
//             },
//           ],
//           margin: [5, 5, 5, 5],
//         };

//         if (index !== selectedDesigns.length - 1) {
//           label.stack.push({ text: "", pageBreak: "after" });
//         }

//         return label;
//       })
//     );

//     const docDefinition = {
//       pageSize: { width: 283, height: 141 }, // 100mm x 50mm
//       pageMargins: [5, 5, 5, 5],
//       content,
//     };

//     pdfMake.createPdf(docDefinition).print(); // open print dialog
//   };

//   return (
//     <div className="content-body">
//       <div className="container-fluid">
//         <div className="form-head d-flex justify-content-between align-items-center mb-3">
//           <h4>Barcode List</h4>
//           <div className="d-flex align-items-center">
//             <img
//               src="/assets/images/kidskart/icon/printer.png"
//               alt="Print Icon"
//               className="cursor-pointer me-3"
//               onClick={handlePrint}
//               title="Print Barcodes"
//             />
//             <Link
//               to={`/rate-diary/list?page=${backPage}${
//                 search ? `&search=${search}` : ""
//               }`}
//             >
//               <img
//                 src="/assets/images/kidskart/icon/back-button.png"
//                 alt="Back"
//                 title="Back to Designs"
//               />
//             </Link>
//           </div>
//         </div>

//         {/* Preview (optional) */}
//         <div className="row p-4">
//           {selectedDesigns.map((design, index) => (
//             <div className="col-md-6" key={index}>
//               <div className="card p-3 text-center">
//                 {/* <img
//                   src={generateBarcodeDataUrl(design.design_id)}
//                   alt="Barcode"
//                   style={{ height: 80 }}
//                 /> */}
//                 <Barcode value={design.design_id} displayValue={false}/>
//                 <div className="mt-2 ms-1 row text-start">
//                   <div className="col-sm-4">{design.brand_name}</div>
//                   <div className="col-sm-6">{design.design_id}</div>
//                   <div className="col-sm-4">{formatPrice(design.design_rate)}</div>
//                   <div className="col-sm-6">{design.barcode_date}</div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// import React from "react";
// import { useLocation, Link } from "react-router-dom";
// import JsBarcode from "jsbarcode";
// const pdfMake = require("pdfmake/build/pdfmake");
// const pdfFonts = require("pdfmake/build/vfs_fonts");

// pdfMake.vfs = pdfFonts.vfs;

// export default function BarcodeListPrint() {
//   const location = useLocation();
//   const { selectedDesigns } = location.state || { selectedDesigns: [] };

//   const queryParams = new URLSearchParams(location.search);
//   const backPage = parseInt(queryParams.get("page"));
//   const search = queryParams.get("search");

//   const formatPrice = (rate) => {
//     const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
//     return price >= 1000
//       ? `4${price.toString().charAt(0)} / ${price
//           .toString()
//           .slice(-3)
//           .padStart(3, "0")}`
//       : `4${price.toString().charAt(0)} / ${price
//           .toString()
//           .slice(-2)
//           .padStart(2, "0")}`;
//   };

//   // Generate high-quality barcode image using SVG to PNG via canvas
//   const generateBarcodeDataUrl = (text) => {
//     return new Promise((resolve) => {
//       const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//       JsBarcode(svg, text, {
//         format: "CODE128",
//         displayValue: false,
//         width: 2.5, // thicker bars = better print scan
//         height: 80,
//         margin: 0,
//         background: "#ffffff",
//         lineColor: "#000000",
//       });

//       const svgData = new XMLSerializer().serializeToString(svg);
//       const svgBlob = new Blob([svgData], {
//         type: "image/svg+xml;charset=utf-8",
//       });
//       const url = URL.createObjectURL(svgBlob);

//       const img = new Image();
//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         canvas.width = img.width * 2; // 2x scale for sharpness
//         canvas.height = img.height * 2;
//         const ctx = canvas.getContext("2d");
//         ctx.scale(2, 2);
//         ctx.drawImage(img, 0, 0);
//         URL.revokeObjectURL(url);
//         resolve(canvas.toDataURL("image/png"));
//       };
//       img.src = url;
//     });
//   };

//   const handlePrint = async () => {
//     const content = await Promise.all(
//       selectedDesigns.map(async (design, index) => {
//         const barcodeImage = await generateBarcodeDataUrl(design.design_id);

//         const label = {
//           stack: [
//             { image: barcodeImage, width: 250, alignment: "center" },
//             {
//               table: {
//                 widths: ["*", "*"],
//                 body: [
//                   [
//                     { text: design.brand_name, fontSize: 10 },
//                     {
//                       text: design.design_id,
//                       alignment: "right",
//                       fontSize: 10,
//                     },
//                   ],
//                   [
//                     { text: formatPrice(design.design_rate), fontSize: 10 },
//                     {
//                       text: design.barcode_date,
//                       alignment: "right",
//                       fontSize: 10,
//                     },
//                   ],
//                 ],
//               },
//               layout: "noBorders",
//               margin: [12, 5, 12, 0],
//             },
//           ],
//           margin: [5, 5, 5, 5],
//         };

//         if (index !== selectedDesigns.length - 1) {
//           label.stack.push({ text: "", pageBreak: "after" });
//         }

//         return label;
//       })
//     );

//     const docDefinition = {
//       pageSize: { width: 283, height: 141 }, // 100mm x 50mm in points
//       pageMargins: [5, 5, 5, 5],
//       content,
//     };

//     pdfMake.createPdf(docDefinition).print(); // Open system print dialog
//   };

//   return (
//     <div className="content-body">
//       <div className="container-fluid">
//         <div className="form-head d-flex justify-content-between align-items-center mb-3">
//           <h4>Barcode List</h4>
//           <div className="d-flex align-items-center">
//             <img
//               src="/assets/images/kidskart/icon/printer.png"
//               alt="Print Icon"
//               className="cursor-pointer me-3"
//               onClick={handlePrint}
//               title="Print Barcodes"
//             />
//             <Link
//               to={`/rate-diary/list?page=${backPage}${
//                 search ? `&search=${search}` : ""
//               }`}
//             >
//               <img
//                 src="/assets/images/kidskart/icon/back-button.png"
//                 alt="Back"
//                 title="Back to Designs"
//               />
//             </Link>
//           </div>
//         </div>

//         {/* Optional Barcode Preview */}
//         <div className="row p-4">
//           {/* {selectedDesigns.map((design, index) => (
//             <div className="col-md-6" key={index}>
//               <div className="card p-3 text-center">
//                 <img
//                   src={URL.createObjectURL(
//                     new Blob([
//                       new XMLSerializer().serializeToString(
//                         JsBarcode(document.createElementNS("http://www.w3.org/2000/svg", "svg"), design.design_id, {
//                           displayValue: false,
//                           width: 2.2,
//                           height: 80,
//                         })
//                       ),
//                     ])
//                   )}
//                   alt="Preview"
//                   style={{ height: 80 }}
//                 />
//                 <div className="mt-2 ms-1 row text-start">
//                   <div className="col-sm-4">{design.brand_name}</div>
//                   <div className="col-sm-6">{design.design_id}</div>
//                   <div className="col-sm-4">{formatPrice(design.design_rate)}</div>
//                   <div className="col-sm-6">{design.barcode_date}</div>
//                 </div>
//               </div>
//             </div>
//           ))} */}
//           {selectedDesigns.map((design, index) => (
//             <div className="col-md-6" key={index}>
//               <div className="card p-3 text-center">
//                 {/* Generate and insert barcode dynamically using canvas for preview */}
//                 <canvas
//                   ref={(el) => {
//                     if (el) {
//                       JsBarcode(el, design.design_id, {
//                         format: "CODE128",
//                         displayValue: false,
//                         width: 3,
//                         height: 80,
//                         margin: 0,
//                       });
//                     }
//                   }}
//                 />
//                 <div className="mt-2 ms-1 row text-start text-black">
//                   <div className="col-sm-4">{design.brand_name}</div>
//                   <div className="col-sm-6">{design.design_id}</div>
//                   <div className="col-sm-4">
//                     {formatPrice(design.design_rate)}
//                   </div>
//                   <div className="col-sm-6">{design.barcode_date}</div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// import React from "react";
// import { useLocation, Link } from "react-router-dom";
// import JsBarcode from "jsbarcode";
// const pdfMake = require("pdfmake/build/pdfmake");
// const pdfFonts = require("pdfmake/build/vfs_fonts");

// pdfMake.vfs = pdfFonts.vfs;

// export default function BarcodeListPrint() {
//   const location = useLocation();
//   const { selectedDesigns } = location.state || { selectedDesigns: [] };

//   const queryParams = new URLSearchParams(location.search);
//   const backPage = parseInt(queryParams.get("page"));
//   const search = queryParams.get("search");

//   const formatPrice = (rate) => {
//     const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
//     return price >= 1000
//       ? `4${price.toString().charAt(0)} / ${price.toString().slice(-3).padStart(3, "0")}`
//       : `4${price.toString().charAt(0)} / ${price.toString().slice(-2).padStart(2, "0")}`;
//   };

//   const generateBarcodeDataUrl = (text) => {
//     return new Promise((resolve) => {
//       const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//       JsBarcode(svg, text, {
//         format: "CODE128",
//         displayValue: false,
//         width: 3,
//         height: 100,
//         margin: 0,
//         background: "transparent", // no background
//         lineColor: "#000000",
//       });

//       const svgData = new XMLSerializer().serializeToString(svg);
//       const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
//       const url = URL.createObjectURL(svgBlob);

//       const img = new Image();
//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         canvas.width = img.width;
//         canvas.height = img.height;
//         const ctx = canvas.getContext("2d");
//         // ✅ Do not fill canvas — leave transparent
//         ctx.drawImage(img, 0, 0);
//         URL.revokeObjectURL(url);
//         resolve(canvas.toDataURL("image/png"));
//       };
//       img.src = url;
//     });
//   };

//   const handlePrint = async () => {
//     const content = await Promise.all(
//       selectedDesigns.map(async (design, index) => {
//         const barcodeImage = await generateBarcodeDataUrl(design.design_id);

//         const label = {
//           stack: [
//             { image: barcodeImage, width: 220, alignment: "center" },
//             {
//               table: {
//                 widths: ["*", "*"],
//                 body: [
//                   [
//                     { text: design.brand_name, fontSize: 10 },
//                     { text: design.design_id, alignment: "right", fontSize: 10 },
//                   ],
//                   [
//                     { text: formatPrice(design.design_rate), fontSize: 10 },
//                     { text: design.barcode_date, alignment: "right", fontSize: 10 },
//                   ],
//                 ],
//               },
//               layout: "noBorders",
//               margin: [22, 5, 22, 0],
//             },
//           ],
//           margin: [5, 5, 5, 5],
//         };

//         if (index !== selectedDesigns.length - 1) {
//           label.stack.push({ text: "", pageBreak: "after" });
//         }

//         return label;
//       })
//     );

//     const docDefinition = {
//       pageSize: { width: 283, height: 141 }, // 100mm x 50mm
//       pageMargins: [5, 5, 5, 5],
//       content,
//     };

//     pdfMake.createPdf(docDefinition).print();
//   };

//   return (
//     <div className="content-body">
//       <div className="container-fluid">
//         <div className="form-head d-flex justify-content-between align-items-center mb-3">
//           <h4>Barcode List</h4>
//           <div className="d-flex align-items-center">
//             <img
//               src="/assets/images/kidskart/icon/printer.png"
//               alt="Print Icon"
//               className="cursor-pointer me-3"
//               onClick={handlePrint}
//               title="Print Barcodes"
//             />
//             <Link to={`/rate-diary/list?page=${backPage}${search ? `&search=${search}` : ""}`}>
//               <img src="/assets/images/kidskart/icon/back-button.png" alt="Back" title="Back to Designs" />
//             </Link>
//           </div>
//         </div>

//         {/* Live Preview */}
//         <div className="row p-4">
//           {selectedDesigns.map((design, index) => (
//             <div className="col-md-6" key={index}>
//               <div className="card p-4 text-center">
//                 <canvas
//                   ref={(el) => {
//                     if (el) {
//                       JsBarcode(el, design.design_id, {
//                         format: "CODE128",
//                         displayValue: false,
//                         width: 3,
//                         height: 100,
//                         margin: 0,
//                         background: "transparent",
//                         lineColor: "#000000",
//                       });
//                     }
//                   }}
//                 />
//                 <div className="mt-2 ms-1 row text-start text-black">
//                   <div className="col-sm-4">{design.brand_name}</div>
//                   <div className="col-sm-6">{design.design_id}</div>
//                   <div className="col-sm-4">{formatPrice(design.design_rate)}</div>
//                   <div className="col-sm-6">{design.barcode_date}</div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useRef } from "react";
// import { useLocation, Link } from "react-router-dom";
// import Barcode from "react-barcode";

// export default function BarcodeListPrint() {
//   const location = useLocation();
//   const { selectedDesigns } = location.state || { selectedDesigns: [] };
//   const queryParams = new URLSearchParams(location.search);
//   const backPage = parseInt(queryParams.get("page"));
//   const search = queryParams.get("search");

//   const barcodeRef = useRef(null);

//   const formatPrice = (rate) => {
//     const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
//     return price >= 1000
//       ? `4${price.toString().charAt(0)} / ${price.toString().slice(-3).padStart(3, "0")}`
//       : `4${price.toString().charAt(0)} / ${price.toString().slice(-2).padStart(2, "0")}`;
//   };

//   const handlePrint = () => {
//     const printWindow = window.open("", "_blank");
//     if (printWindow && barcodeRef.current) {
//       printWindow.document.open();
//       printWindow.document.write(`
//         <!DOCTYPE html>
//         <html>
//         <head>
//           <style>
//             @page {
//               size: 100mm 50mm;
//               margin: 0;
//             }
//             @media print {
//               body {
//                 margin: 0;
//                 padding: 0;
//               }
//               .label {
//                 width: 100mm;
//                 height: 50mm;
//                 box-sizing: border-box;
//                 page-break-after: always;
//                 display: flex;
//                 flex-direction: column;
//                 justify-content: center;
//                 align-items: center;
//                 font-family: Arial, sans-serif;
//                 font-size: 10pt;
//               }
//               .row {
//                 width: 80%;
//                 display: flex;
//                 justify-content: space-between;
//                 margin-top: 5px;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           ${barcodeRef.current.innerHTML}
//         </body>
//         </html>
//       `);
//       printWindow.document.close();
//       printWindow.focus();
//       printWindow.print();
//     }
//   };

//   return (
//     <div className="content-body">
//       <div className="container-fluid">
//         <div className="form-head d-flex justify-content-between align-items-center mb-3">
//           <h4>Barcode List</h4>
//           <div className="d-flex align-items-center">
//             <img
//               src="/assets/images/kidskart/icon/printer.png"
//               alt="Print"
//               className="cursor-pointer me-3"
//               onClick={handlePrint}
//               title="Print Barcodes"
//             />
//             <Link to={`/rate-diary/list?page=${backPage}${search ? `&search=${search}` : ""}`}>
//               <img
//                 src="/assets/images/kidskart/icon/back-button.png"
//                 alt="Back"
//                 title="Back to Designs"
//               />
//             </Link>
//           </div>
//         </div>

//         {/* Barcode Layout */}
//         <div ref={barcodeRef}>
//           {selectedDesigns.map((design, index) => (
//             <div className="label" key={index}>
//               <Barcode
//                 value={design.design_id}
//                 displayValue={false}
//                 width={1}
//                 height={60}
//                 margin={0}
//                 background="transparent"
//                 lineColor="#000000"
//               />
//                 <div className="row">
//                 <div className="col-6">{design.brand_name}</div>
//                 <div className="col-6">{design.design_id}</div>
//               </div>
//               <div className="row">
//                 <div className="col-6">{formatPrice(design.design_rate)}</div>
//                 <div className="col-6">{design.barcode_date}</div>
//               </div>

//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

//  @page {
//                size: 100mm 50mm;
//               margin: 0;
//            }
//                 @media print {
//                   body {
//                     margin: 0;
//                     padding: 0;
//                     font-family: Arial, sans-serif;
//                     font-size: 10px;
//                   }
//                   .row {
//                     display: flex;
//                     flex-wrap: wrap;
//                     margin: 0;
//                   }
//                   .col-md-6 {
//                     display: block;
//                     width: 100mm;
//                     margin: 0 auto;
//                     padding: 0;
//                     page-break-after: always;
//                   }
//                   .card {
//                     box-shadow: none;
//                     border: none;
//                     margin: 0 auto;
//                   }
//                   .card-body {
//                     padding: 0mm; /* Adjust padding for better fit */
//                     text-align: left;
//                   }
//                   .col-sm-6 {
//                     display: inline-block;
//                     width: 72mm; /* Adjust for two labels per row */
//                     margin: 0;
//                     padding: 0;
//                   }
//                   .col-sm-4 {
//                     display: inline-block;
//                     width: 25mm; /* Adjust for two labels per row */
//                     margin: 0;
//                     padding: 0;
//                   }
//                     .col-sm-2 {
//                     display: inline-block;
//                     width: 3mm; /* Adjust for two labels per row */
//                     margin: 0;
//                     padding: 0;
//                   }
//                   .barcode {
//                     width: 100%;
//                     align-items: center;
//                   }

// import React, { useRef } from "react";
// import { useLocation, Link } from "react-router-dom";
// import Barcode from "react-barcode";

// export default function BarcodeListPrint() {
//   const location = useLocation();
//   const { selectedDesigns } = location.state || { selectedDesigns: [] };

//   const queryParams = new URLSearchParams(location.search);
//   const backPage = parseInt(queryParams.get("page"));
//   const search = queryParams.get("search");

//   console.log("selectedDesigns", selectedDesigns);

//   const barcodeRef = useRef(null);

//   const handlePrint = () => {
//     if (barcodeRef.current) {
//       const printWindow = window.open("", "_blank");
//       if (printWindow) {
//         printWindow.document.open();
//         printWindow.document.write(`
//           <!DOCTYPE html>
//           <html>
//             <head>
//               <style>

//               @page {
//   size: 100mm 50mm;
//   margin: 0;
// }
// @media print {
//   body {
//     margin: 0;
//     padding: 0;
//     -webkit-print-color-adjust: exact;
//   }
//   .barcode1 {
//     width: 100%;
//     // height: 20mm;
//     margin: 0;
//     padding: 0;
//   }

//   .col-md-6 {
//     width: 100mm;
//     height: 50mm;
//     padding: 0;
//     margin: 0 auto;
//     page-break-after: always;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }

//   .card {
//     width: 100mm;
//     height: 50mm;
//     border: none;
//     box-shadow: none;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   .card-body {
//     width: 100mm;
//     padding: 0;
//     text-align: center;
//     margin: 2mm;
//   }

//   .barcode {
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     justify-content: center;
//     padding: 1mm;
//     // margin-left: 3mm;
//   }

//   // .barcode1 {
//   //   width: 100%;
//   //   height: 15mm;
//   //   color: gray;
//   //   margin-bottom: 5px;
//   // }

//   .barcode canvas {
//     margin-bottom: 4px;
//   }

//   .info-row {
//     display: flex;
//     justify-content: space-between;
//     width: 100mm;
//     color: black;
//     // margin-left: 3mm;
//     font-size: 12px;
//   }

//   .info-cell {
//     // flex: 1;
//     text-align: right;
//     padding-right: 8px;
//   }

//   .info-cell.right {
//     text-align: left;
//     padding-left: 8px;
//   }

//   .col-5 {
//     width: 40mm;
//   }

//   .col-7 {
//     width: 60mm;
//   }
// }
// }

//                 }
//               </style>
//             </head>
//             <body>
//               <div>
//                 ${barcodeRef.current.innerHTML}
//               </div>
//             </body>
//           </html>
//         `);
//         printWindow.document.close();
//         printWindow.focus();
//         printWindow.print();
//         printWindow.close();
//       }
//     }
//   };

//   const formatPrice = (rate) => {
//     const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
//     const formattedPrice =
//       price >= 1000
//         ? `4${price.toString().charAt(0)} / ${price
//             .toString()
//             .slice(-3)
//             .padStart(3, "0")}`
//         : `4${price.toString().charAt(0)} / ${price
//             .toString()
//             .slice(-2)
//             .padStart(2, "0")}`;
//     return formattedPrice;
//   };

//   return (
//     <div className="content-body">
//       <div className="container-fluid">
//         {/* Header */}
//         <div className="form-head d-flex justify-content-between align-items-center mb-3">
//           <h4>Barcode List</h4>
//           <div className="d-flex align-items-center">
//             <img
//               src="/assets/images/kidskart/icon/printer.png"
//               alt="Print Icon"
//               className="cursor-pointer me-3"
//               onClick={handlePrint}
//               title="Print Barcodes"
//             />
//             <Link
//               to={`/rate-diary/list?page=${backPage}${
//                 search ? `&search=${search}` : ""
//               }`}
//             >
//               <img
//                 src="/assets/images/kidskart/icon/back-button.png"
//                 alt="Back"
//                 title="Back to Designs"
//               />
//             </Link>
//           </div>
//         </div>

//         {/* Barcode Cards */}
//         <div className="row" ref={barcodeRef}>
//           {selectedDesigns.map((design, index) => {
//             return (
//               <div className="col-md-6 mb-4 m-0" key={index}>
//                 <div className="card shadow-sm">
//                   <div className="card-body text-center">
//                     {/* Barcode */}
//                     {/* <div style={{ background: "#fff" }} className="barcode">
//                       <Barcode value={design.design_id} displayValue={false} width={1} height={60}/>
//                       <div
//                         className="row text-start"
//                         style={{ color: "black" }}
//                       >
//                         <div className="col-sm-2 fw-bold"></div>
//                         <div className="col-sm-4 fw-bold">
//                           {design.brand_name}
//                         </div>
//                         <div className="col-sm-6 fw-bold">
//                           {design.design_id}
//                         </div>
//                         <div className="col-sm-2 fw-bold"></div>
//                         <div className="col-sm-4 fw-bold">
//                           {formatPrice(design.design_rate)}
//                         </div>
//                         <div className="col-sm-6 fw-bold">
//                           {design.barcode_date}
//                         </div>
//                       </div>
//                     </div> */}
//                     <div className="barcode text-black">
//                       {/* <Barcode
//                         value={design.design_id}
//                         displayValue={false}
//                         className="barcode1"
//                       /> */}
//                       <Barcode
//                         value={design.design_id}
//                         displayValue={false}
//                         width={2} // Narrow bar width
//                         height={80} // Barcode height (~15mm)
//                         renderer="svg" // SVG ensures better quality
//                         // background="#ffffff"
//                         className="barcode1"
//                       />
//                       <div className="info-row row">
//                         <div className="info-cell width-30 col-5">
//                           {design.barcode_date}
//                         </div>
//                         <div className="info-cell right width-70 col-7">
//                           {design.design_id}
//                         </div>
//                       </div>
//                       <div className="info-row row">
//                         <div className="info-cell width-30 col-5">
//                           {formatPrice(design.design_rate)}
//                         </div>
//                         <div className="info-cell right width-70 col-7">
//                           {design.brand_name}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

import JsBarcode from "jsbarcode";
import React, { useEffect, useRef } from "react";
import { useLocation, Link } from "react-router-dom";

export default function BarcodeListPrint() {
  const location = useLocation();
  const { selectedDesigns } = location.state || { selectedDesigns: [] };
  const queryParams = new URLSearchParams(location.search);
  const backPage = parseInt(queryParams.get("page"));
  const search = queryParams.get("search");
  const barcodeRef = useRef(null);

  const SVGBarcode = ({ value }) => {
    const svgRef = useRef(null);

    useEffect(() => {
      if (svgRef.current) {
        JsBarcode(svgRef.current, value, {
          format: "CODE128",
          width: 2, // narrow bar
          height: 70, // tall enough for thermal
          displayValue: false,
          margin: 0,
        });
      }
    }, [value]);

    return <svg ref={svgRef} className="barcode1" />;
  };

  const handlePrint = () => {
    if (barcodeRef.current) {
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <style>
                @page {
                  size: 100mm 50mm;
                  margin: 0;
                }
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                    -webkit-print-color-adjust: exact;
                  }
                  .barcode1 {
                    width: 100%;
                    margin: 0;
                    padding: 0;
                    margin-bottom: 2mm;
                  }
                  .col-md-6 {
                    width: 100mm;
                    height: 50mm;
                    padding: 0;
                    margin: 0 auto;
                    page-break-after: always;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                  .card {
                    width: 100mm;
                    height: 50mm;
                    border: none;
                    box-shadow: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                  .card-body {
                    width: 100mm;
                    padding: 0;
                    text-align: center;
                    // margin: 3mm;
                  }
                  .barcode {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    padding: 2mm;
                  }
                  .info-row {
                    display: flex;
                    justify-content: space-between;
                    width: 100mm;
                    color: black;
                    font-weight: bold;
                    // font-size: 12pt;
                    // font-family: sans-serif;
                    font-family: 'Courier New', monospace;
                    font-size: 20px;                      
                    // color: #000;                          
                    -webkit-font-smoothing: none;
                    font-smooth: never;
                    text-rendering: optimizeLegibility;
                  }
                  .info-cell {
                    text-align: right;
                    padding-right: 8px;
                    margin-bottom: 1mm;
                  }
                  .info-cell.right {
                    text-align: left;
                    padding-left: 8px;
                    margin-bottom: 1mm;
                  }
                  .col-5 {
                    width: 35mm;
                  }
                  .col-7 {
                    width: 65mm;
                  }
                }
              </style>
            </head>
            <body>
              <div>${barcodeRef.current.innerHTML}</div>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }
    }
  };

  const formatPrice = (rate) => {
    const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
    const formattedPrice =
      price >= 1000
        ? `4${price.toString().charAt(0)} / ${price
            .toString()
            .slice(-3)
            .padStart(3, "0")}`
        : `4${price.toString().charAt(0)} / ${price
            .toString()
            .slice(-2)
            .padStart(2, "0")}`;
    return formattedPrice;
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="form-head d-flex justify-content-between align-items-center mb-3">
          <h4>Barcode List</h4>
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/kidskart/icon/printer.png"
              alt="Print Icon"
              className="cursor-pointer me-3"
              onClick={handlePrint}
              title="Print Barcodes"
            />
            <Link
              to={`/rate-diary/list?page=${backPage}${
                search ? `&search=${search}` : ""
              }`}
            >
              <img
                src="/assets/images/kidskart/icon/back-button.png"
                alt="Back"
                title="Back to Designs"
              />
            </Link>
          </div>
        </div>

        <div className="row" ref={barcodeRef}>
          {selectedDesigns.map((design, index) => (
            <div className="col-md-6 mb-4 m-0" key={index}>
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <div className="barcode text-black">
                    <SVGBarcode value={design.design_id} />
                    <div className="info-row row">
                      <div className="info-cell width-30 col-5">
                        {design.barcode_date}
                      </div>
                      <div className="info-cell right width-70 col-7">
                        {design.design_id}
                      </div>
                    </div>
                    <div className="info-row row">
                      <div className="info-cell width-30 col-5">
                        {formatPrice(design.design_rate)}
                      </div>
                      <div className="info-cell right width-70 col-7">
                        {design.brand_name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
